import * as React from 'react';
import { LinkButton, UIHeading1, UIText1 } from '@cian/ui-kit';

import * as styles from './DobroListingStatusPage.css';

export interface IDobroListingStatusPageProps {
  title: string;
  subtitle?: string;
  buttonText?: string;
  buttonLink?: string;
}

export function DobroListingStatusPage(props: IDobroListingStatusPageProps) {
  return (
    <div className={styles.page}>
      <div className={styles.text}>
        <UIHeading1>{props.title}</UIHeading1>
      </div>
      {props.subtitle && (
        <div className={styles.text}>
          <UIText1>{props.subtitle}</UIText1>
        </div>
      )}
      {props.buttonText && props.buttonLink && (
        <div className={styles.button}>
          <LinkButton href={props.buttonLink}>{props.buttonText}</LinkButton>
        </div>
      )}
    </div>
  );
}
